import { render } from "./all-soal-jodoh.vue?vue&type=template&id=68489b96&scoped=true"
import script from "./all-soal-jodoh.vue?vue&type=script&lang=js"
export * from "./all-soal-jodoh.vue?vue&type=script&lang=js"

import "./all-soal-jodoh.vue?vue&type=style&index=0&id=68489b96&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68489b96"]])

export default __exports__